<template>
    <div :key="keyD" class="raptors-group">
        <h2 class="title" v-if="salons.length > 0">{{$t('reports.cummulative.title')}}</h2>
        <div class="select-container" v-if="salons.length > 0 && loaded">
            <!--            <h4>Salony</h4>-->
            <VueMultiselect :close-on-select="true"
                            :deselectLabel="$t('multiselect.deselectLabel')"
                            :multiple="true"
                            :options="salons"
                            :placeholder="$t('multiselect.placeholder')"
                            :selectLabel="$t('multiselect.selectLabel')"
                            :selectedLabel="$t('multiselect.selectedLabel')"
                            label="name"
                            track-by="id"
                            v-model="selectedSalons"
                            :limit="15"
                            :limit-text=" count => `+ ${count}`"
            >
            </VueMultiselect>
        </div>
        <div class="charts-container container" v-if="salons.length > 0">
            <div class="top">
                <h4>{{$t('general.entriesCount')}}</h4>
            </div>
            <div class="controls" v-if="loaded && loadedTable">
                <div class="date-control">
                    <button :class="{active: selectedPredef === 'counters'}" @click="selectedPredef = 'counters'
                            startDate = dates.today.startDate
endDate = dates.today.endDate;
">
                        {{$t('general.today')}}
                    </button>
                    |
                    <button :class="{active: selectedPredef === 'countersYesterday'}"
                            @click="selectedPredef = 'countersYesterday'
                            startDate = dates.yesterday.startDate
endDate = dates.yesterday.endDate;
">{{$t('general.yesterday')}}
                    </button>
                    |
                    <button :class="{active: selectedPredef === 'countersWeek'}"
                            @click="selectedPredef = 'countersWeek'
                            startDate = dates.week.startDate
endDate = dates.week.endDate;

">{{$t('general.week')}}
                    </button>
                    |
                    <button :class="{active: selectedPredef === 'countersMonth'}"
                            @click="selectedPredef = 'countersMonth'
                            startDate = dates.month.startDate
endDate = dates.month.endDate;
">{{$t('general.month')}}
                    </button>
                    |
                    <div class="picker-container">
                        <span class="active">{{$t('general.from')}}:</span>
                        <md-datepicker :md-disabled-dates="fromBlocker" @md-closed="selectedPredef='period'"
                                       md-immediately
                                       v-model="startDate">
                        </md-datepicker>
                    </div>

                    <div class="picker-container">
                        <span class="active">{{$t('general.to')}}:</span>
                        <md-datepicker :md-disabled-dates="gateKeeper" @md-closed="selectedPredef='period'"
                                       md-immediately v-model="endDate"></md-datepicker>
                    </div>
                </div>
                <button @click="loadData" class="save">{{$t('buttons.refresh')}}</button>
                <div :title="$t('general.printPDF')" @click="printCharts" class="link print"
                     v-if="loaded && loadedTable">
                    <img src="../../assets/images/print.svg">
                    <span>{{$t('general.printPDF')}}</span>
                </div>

                <button :title="$t('general.downloadCSV')" @click="downloadCSV" class="link download"
                        v-if="loaded && loadedTable"><img
                        src="../../assets/images/download.svg"><span>{{$t('general.downloadCSV')}}</span>
                </button>
                <ChartSwitcher :currentState="state" @changeChart="changeChart"></ChartSwitcher>

            </div>
            <div :key="keyDate" class="charts" v-if="loaded">
                <bar-chart :chart-data="chartData"
                           :height="chartHeight" :options="style"
                           v-if="state===0 && predefinedChartData && loaded"></bar-chart>
                <line-chart :chart-data="lineData" :height="lineChartHeight" :options="lineStyle"
                            v-if="state===1 && loaded"
                ></line-chart>
            </div>
            <Preloader v-if="!loaded"></Preloader>
        </div>

        <!--<pre class="language-json"><code>{{ value  }}</code></pre>-->
        <div class="table-container" v-if="salons.length > 0">
            <div class="top" v-if="loadedTable">
                <button
                        :class="{active: tableFilter === 'daysHoursPeriod'}"
                        @click="tableFilter = 'daysHoursPeriod'"
                >
                    {{$t('general.daysHoursPeriod')}}
                </button>
                |
                <button
                        :class="{active: tableFilter === 'weeksDaysPeriod'}"
                        @click="tableFilter= 'weeksDaysPeriod'"
                >
                    {{$t('general.weeksDaysPeriod')}}
                </button>
                |
                <button
                        :class="{active: tableFilter === 'monthsDaysPeriod'}"
                        @click="tableFilter = 'monthsDaysPeriod'"
                >
                    {{$t('general.monthsDaysPeriod')}}
                </button>
            </div>
            <CountsTable :data="newTable" :translatable="translatable"
                         v-if="loadedTable"></CountsTable>
            <Preloader v-if="!loadedTable"></Preloader>
        </div>
        <div v-else>
            <h2 class="title">{{$t('messages.noSalons')}}</h2>
        </div>
        <div :class="`printable-chart`" :id="`printable-chart-${index}`" class="printable-charts"
             v-for="(chart,index) in printChartData"
             v-if="printing">
            <bar-chart :chart-data="chart" :height="600" :options="printStyle"></bar-chart>
        </div>
        <Preloader class="printing" v-if="printing"></Preloader>
    </div>

</template>

<script>
import VueMultiselect from 'vue-multiselect/src/Multiselect';
import JsonCSV from 'vue-json-csv';
import jsPDF from 'jspdf';
import LineChart from '@/components/charts/LineChart.js';
import BarChart from '@/components/charts/BarChart.js';
import { RepositoryFactory } from '@/api/RepositoryFactory';
import Preloader from '@/components/helpers/Preloader';
import ChartSwitcher from '@/components/helpers/ChartSwitcher';
import CountsTable from '@/components/helpers/CountsTable';
import 'vue-material/dist/vue-material.min.css';
import 'jspdf-autotable';
import XLSX from 'xlsx';
import SubmitButton from '@/components/helpers/SubmitButton';

const DataRepository = RepositoryFactory.get('data');
const SalonsRepository = RepositoryFactory.get('salons');

export default {
  name: 'Cumulative',
  components: {
    SubmitButton,
    CountsTable,
    ChartSwitcher,
    VueMultiselect,
    Preloader,
    BarChart,
    LineChart,
    JsonCSV,
  },
  data() {
    return {
      maxChartValue: 200,
      salons: [],
      barChartTitle: '',
      lineChartTitle: '',
      chartCount: 1,
      printing: false,
      printChartData: [],
      tableCSVData: [],
      CSVOrder: [],
      keyD: 0,
      value: [],
      loadedTable: false,
      state: 0,
      tableFilter: 'daysHoursPeriod',
      // options: [],
      startDate: '',
      endDate: '',
      selectedSalons: [],
      // salons: [],
      loaded: false,
      today: '',
      currentDay: '',
      total: 0,
      barData: {},
      linData: [],
      newTable: {},
      selectedPredef: 'counters',
      translatable: false,
      predefinedChartData: [],
      delimiter: this.$store.getters.delimiter,
      barTitle: '',
      barTrans: '',
      lineData: {
        labels: ['loading'],
        data: [0],
      },
      dates: {
        today: {
          startDate: '',
          endDate: '',
        },
        yesterday: {
          startDate: '',
          endDate: '',
        },
        week: {
          startDate: '',
          endDate: '',
        },
        month: {
          startDate: '',
          endDate: '',
        },
      },
      keyDate: 0,
      gateKeeper: (date) => {
        const blockedDate = new Date(this.startDate);
        blockedDate.setHours(0, 0, 0);
        const today = new Date().setHours(0, 0, 0);
        if (date < blockedDate || date > today) {
          return true;
        }

        return false;
      },
      fromBlocker: (date) => {
        const today = new Date();
        if (date > today) {
          return true;
        }
        return false;
      },
    };
  },
  computed: {
    language() {
      return this.$i18n.locale;
    },
    lineStyle() {
      return {
        title: {
          display: true,
          text: this.lineChartTitle,
        },
        height: 320,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.$t('general.hour'),
            },
          }],
          yAxes: [{
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.$t('general.counts'),
            },
          }],
        },
      };
    },
    groupID() {
      return this.$store.getters.selectedGroup.id;
    },
    csvBarData() {
      if (this.loaded) {
        return this.barData[this.selectedPredef];
      }
      return [];
    },
    chartHeight() {
      if (this.loaded) {
        const hypothetical = this.chartData.labels.length * 75;
        if (hypothetical > 320) {
          return hypothetical;
        }
      }
      return 320;
    },
    lineChartHeight() {
      const hypothetical = this.chartHeight / 8;
      if (hypothetical > 320) {
        return hypothetical;
      }
      return 320;
    },
    selectedSalonsString() {
      let list = '';
      this.selectedSalons.forEach((v) => {
        list += `${v.id},`;
      });
      return list;
    },
    style() {
      return {
        maintainAspectRatio: false,
        title: {
          display: true,
          text: this.barChartTitle,
        },
        layout: {
          padding: {
            left: 50,
            right: 50,
            top: 50,
            bottom: 50,
          },
        },
        scales:
          {
            xAxes: [{
              minBarLength: 2,
              gridLines: {
                offsetGridLines: true,
              },
              ticks: {
                beginAtZero: true,
                min: 0,
              },
            }],
            yAxes:
              [{
                yAxes: [{
                  barPercentage: 0.95,
                  categoryPercentage: 1.0,
                  ticks: {
                    beginAtZero: true,
                    min: 0,
                  },
                },
                ],
              }],
          },
      };
    },
    printStyle() {
      return {
        maintainAspectRatio: false,
        title: {
          display: true,
          text: this.barChartTitle,
        },
        layout: {
          padding: {
            left: 50,
            right: 50,
            top: 50,
            bottom: 50,
          },
        },
        scales:
          {
            xAxes: [{
              minBarLength: 2,
              gridLines: {
                offsetGridLines: true,
              },
              ticks: {
                beginAtZero: true,
                min: 0,
                max: Math.ceil(this.maxChartValue / 100) * 100,
              },
            }],
            yAxes:
              [{
                yAxes: [{
                  barPercentage: 0.95,
                  categoryPercentage: 1.0,
                  ticks: {
                    beginAtZero: true,
                    min: 0,
                  },
                },
                ],
              }],
          },
      };
    },
    styleObject() {
      return this.$store.getters.cssConfig;
    },
    chartData() {
      if (this.loaded) {
        return this.predefinedChartData.period;
      }
      return {
        counters: {
          datasets: [],
          labels: ['loading'],
        },
      };
    },
  },
  watch: {
    async groupID(newV) {
      this.salons = await SalonsRepository.getShopsGroup(this.$store.getters.token, newV);
      this.selectedSalons = this.salons;
      if (this.salons.length > 0) {
        await this.loadData();
      }
    },
    language() {
      if (this.loaded) {
        this.barTrans = this.$t('general.reportsTitles.titles.bar.1');
      }
    },
  },

  async mounted() {
    this.barTrans = this.$t('general.reportsTitles.titles.bar.1');
    this.$store.commit('set_api_call', true);
    const salons = await SalonsRepository.getShopsGroup(this.$store.getters.token, this.$store.getters.selectedGroup.id);
    await this.$store.dispatch('setSalons', salons);
    this.salons = salons;
    this.selectedSalons = salons;
    this.$material.locale = {
      startYear: 1900,
      endYear: 2099,
      dateFormat: 'yyyy-MM-dd',
      firstDayOfAWeek: 0,
      days: this.$t('datepicker.days'),
      shortDays: this.$t('datepicker.shortDays'),
      shorterDays: this.$t('datepicker.shorterDays'),
      months: this.$t('datepicker.months'),
      shortMonths: this.$t('datepicker.shortMonths'),
      shorterMonths: this.$t('datepicker.shorterMonths'),
    };
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const yyyy = today.getFullYear();
    const nextWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() + -7);
    const prevMonth = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
    const yesterday = new Date(today.getFullYear(), today.getMonth(), today.getDate() + -1);
    let list = '';
    this.selectedSalons.forEach((v) => {
      list += `${v.id},`;
    });

    this.today = `${yyyy}-${mm}-${dd}`;
    this.dates.today.startDate = this.today;
    this.dates.today.endDate = this.today;
    this.dates.month.endDate = this.today;
    this.dates.week.endDate = this.today;
    this.dates.week.startDate = `${nextWeek.getFullYear()}-${String(nextWeek.getMonth() + 1)
      .padStart(2, '0')}-${String(nextWeek.getDate())
      .padStart(2, '0')}`;
    /*   this.dates.month.startDate = `${prevMonth.getFullYear()}-${String(prevMonth.getMonth() + 1)
                 .padStart(2, '0')}-${String(prevMonth.getDate())
                 .padStart(2, '0')}`; */
    this.dates.month.startDate = `${yyyy}-${mm}-01`;
    this.dates.yesterday.startDate = `${yesterday.getFullYear()}-${String(yesterday.getMonth() + 1)
      .padStart(2, '0')}-${String(yesterday.getDate())
      .padStart(2, '0')}`;
    this.dates.yesterday.endDate = this.dates.yesterday.startDate;

    this.currentDay = `${yyyy}/${mm}/${dd}`;
    this.startDate = this.dates.today.startDate;
    this.endDate = this.dates.today.endDate;
    if (list.length > 0) {
      await this.getTable(list, this.startDate, this.endDate, 'daysHoursPeriod');
      await this.getLineData(list, this.startDate, this.endDate);
      await this.getPeriodData(list, this.startDate, this.endDate);
    }
    this.barTitle = `${this.$t('general.reportsTitles.titles.bar.1') + this.startDate} - ${this.endDate}`;
    this.$store.commit('set_api_call', false);
    // this.switchLoadState();
    this.barChartTitle = `${this.barTrans} ${this.startDate} - ${this.endDate}`;
    this.lineChartTitle = `${this.$t('general.reportsTitles.titles.line.1') + this.startDate} - ${this.endDate}`;
    this.loaded = true;
    this.loadedTable = true;
  },

  methods: {
    async loadData() {
      this.switchLoadState();
      this.$store.commit('set_api_call', true);
      const stateBuffer = this.state;
      await this.getPeriodData(this.selectedSalonsString, this.startDate, this.endDate);
      await this.callTable(this.tableFilter);
      await this.getLineData(this.selectedSalonsString, this.startDate, this.endDate);
      this.state = stateBuffer;
      this.barChartTitle = `${this.barTrans} ${this.startDate} - ${this.endDate}`;
      this.lineChartTitle = `${this.$t('general.reportsTitles.titles.line.1') + this.startDate} - ${this.endDate}`;
      this.$store.commit('set_api_call', false);
      this.switchLoadState();
    },
    generatePrintedCharts() {
      const elements = this.barData[this.selectedPredef];
      const elementsCount = this.barData[this.selectedPredef].length;
      const pages = Math.ceil(elementsCount / 15);
      let n = 0;
      for (n = 0; n < pages; n += 1) {
        const dto = {
          labels: [],
          datasets: [
            {
              label: this.$t('general.entries'),
              backgroundColor: `${this.styleObject.chartPrimaryColor}99`,
              data: [],
            }, {
              label: this.$t('general.exits'),
              backgroundColor: `${this.styleObject.chartSecondaryColor}78`,
              data: [],
            }, {
              label: this.$t('general.unknowns'),
              data: [],
            },
          ],
        };
        for (let i = 0; i < 15; i += 1) {
          const index = (14 * n) + i;
          const data = elements[index];
          if (data !== undefined) {
            dto.labels.push(data[this.$t('csvHeaders.name')]);
            dto.datasets[0].data.push(data[this.$t('csvHeaders.entries')]);
            dto.datasets[1].data.push(data[this.$t('csvHeaders.exits')]);
            dto.datasets[2].data.push(data[this.$t('csvHeaders.unknowns')]);
          }
        }
        this.printChartData.push(dto);
      }
      return pages;
    },
    switchLoadState() {
      this.loaded = !this.loaded;
      this.loadedTable = !this.loadedTable;
    },
    downloadCSV() {
      if (this.loaded && this.loadedTable) {
        const wb = XLSX.utils.book_new();
        const tableSheet = XLSX.utils.json_to_sheet(this.tableCSVData, { header: this.CSVOrder });
        XLSX.utils.book_append_sheet(wb, tableSheet, this.$t('general.tableData'));
        if (this.state === 0) {
          Object.keys(this.barData).forEach((v) => {
            const sheet = XLSX.utils.json_to_sheet(this.barData[v]);
            XLSX.utils.book_append_sheet(wb, sheet, this.$t(`general.reportLabels.${v}`));
          });
          XLSX.writeFile(wb, 'barChart.xlsx');
        } else {
          const sheet = XLSX.utils.json_to_sheet(this.linData);
          XLSX.utils.book_append_sheet(wb, sheet, this.$t('general.reportLabels.period'));
          XLSX.writeFile(wb, 'lineChart.xlsx');
        }
      }
    },
    async getLineData(selectedSalons, startDate, endDate) {
      if (selectedSalons.length > 0) {
        const colorArray = ['#f63', '#ffb399', '#f3f', '#ff9', '#00b3e6',
          '#e6b333', '#3366e6', '#996', '#9f9', '#b34d4d',
          '#80b300', '#809900', '#e6b3b3', '#6680b3', '#66991a',
          '#ff99e6', '#ccff1a', '#ff1a66', '#e6331a', '#3fc',
          '#66994d', '#b366cc', '#4d8000', '#b33300', '#cc80cc',
          '#66664d', '#991aff', '#e666ff', '#4db3ff', '#1ab399',
          '#e666b3', '#33991a', '#c99', '#b3b31a', '#00e680',
          '#4d8066', '#809980', '#e6ff80', '#1aff33', '#993',
          '#ff3380', '#cc0', '#66e64d', '#4d80cc', '#9900b3',
          '#e64d66', '#4db380', '#ff4d4d', '#99e6e6', '#66f'];
        const retrievedData = await DataRepository.getAnalysisData(this.$store.getters.token, selectedSalons, startDate, endDate);
        const dataCollection = {
          labels: [],
          datasets: [],
        };
        Object.keys(retrievedData.rows[Object.keys(retrievedData.rows)[0]].countsData).forEach((val) => {
          dataCollection.labels[val] = val;
        });
        let k = 0;
        Object.keys(retrievedData.rows).forEach((val) => {
          // eslint-disable-next-line eqeqeq
          const currentSalon = this.selectedSalons.find(salon => salon.name === val);
          if (currentSalon !== undefined) {
            const dataset = {
              label: currentSalon.name,
              data: [],
              borderColor: colorArray[k],
            };
            Object.keys(retrievedData.rows[val].countsData).forEach((value) => {
              dataset.data[value] = retrievedData.rows[val].countsData[value];
            });
            dataCollection.datasets.push(dataset);
            k += 1;
            if (k > colorArray.length - 1) {
              k = 0;
            }
            const flatData = {};
            flatData[this.$t('csvHeaders.name')] = currentSalon.name;
            dataset.data.forEach((w, key) => {
              flatData[key] = w;
            });
            this.linData.push(flatData);
          }
        });
        this.lineData = dataCollection;
      }
    },
    async getPeriodData(selectedSalons, dateFrom, dateTo) {
      // this.loaded = false;
      const retrievedData = await DataRepository.getBarChartPeriod(this.$store.getters.token, selectedSalons, dateFrom, dateTo);
      const dataCollection = {
        labels: [],
        datasets: [
          {
            label: this.$t('general.entries'),
            backgroundColor: `${this.styleObject.chartPrimaryColor}99`,
            data: [],
          }, {
            label: this.$t('general.exits'),
            backgroundColor: `${this.styleObject.chartSecondaryColor}78`,
            data: [],
          }, {
            label: this.$t('general.unknowns'),
            data: [],
          },
        ],
      };
      const rawData = [];
      const data = [];
      const entries = [];
      Object.keys(retrievedData.counters).forEach((val) => {
        dataCollection.labels.push(val);
        dataCollection.datasets[1].data.push(retrievedData.counters[val].outSum);
        dataCollection.datasets[2].data.push(retrievedData.counters[val].unknownSum);
        entries.push(retrievedData.counters[val].inSum);
        rawData.push(retrievedData.counters[val].inSum);
        rawData.push(retrievedData.counters[val].outSum);
        rawData.push(retrievedData.counters[val].unknownSum);
        data.push({
          [this.$t('csvHeaders.name')]: val,
          [this.$t('csvHeaders.entries')]: retrievedData.counters[val].inSum,
          [this.$t('csvHeaders.exits')]: retrievedData.counters[val].outSum,
          [this.$t('csvHeaders.unknowns')]: retrievedData.counters[val].unknownSum,
        });
      });
      const color = entries.map(x => `${this.styleObject.chartPrimaryColor}99`);
      color[this.argMax(entries)] = 'red';
      dataCollection.datasets[0] = {
        label: this.$t('general.entries'),
        backgroundColor: color,
        data: entries,
      };
      this.predefinedChartData.period = dataCollection;
      this.barData.period = JSON.parse(JSON.stringify(data));
      this.maxChartValue = rawData[this.argMax(rawData)];
    },
    async callTable(type) {
      this.tableFilter = type;
      if (type === 'monthsDaysPeriod') {
        this.translatable = true;
      } else {
        this.translatable = false;
      }
      await this.getTable(this.selectedSalonsString, this.startDate, this.endDate, type);
    },
    argMax(array) {
      return array.map((x, i) => [x, i]).reduce((r, a) => (a[0] > r[0] ? a : r))[1];
    },
    async getTable(shops, dateStart, dateEnd, type) {
      // this.loadedTable = false;
      this.newTable = await DataRepository.getTableData(this.$store.getters.token, shops, dateStart, dateEnd, type);
      this.createCSV(this.newTable);
      // this.loadedTable = true;
    },
    createCSV(response) {
      const csvdata = [];
      // console.log(response.rows);
      let translateKey = '';
      switch (this.tableFilter) {
        case 'daysHoursPeriod':
          translateKey = '';
          break;
        case 'monthsDaysPeriod':
          translateKey = 'general.months.';
          break;
        default:
          translateKey = '';
          break;
      }
      Object.keys(response.rows).forEach((value, index) => {
        let attachTable = [];
        let rowIndex = '';
        let shop = '';
        if (this.tableFilter === 'weeksDaysPeriod') {
          const translateObject = {};
          Object.keys(response.rows[value].countsData).forEach((v) => {
            translateObject[this.$t(`general.days.${v}`)] = response.rows[value].countsData[v];
          });
          attachTable = translateObject;
          rowIndex = value.split(' ')[0];
          shop = value.replace(value.split(' ')[0], '');
        } else if (this.tableFilter === 'monthsDaysPeriod') {
          const translatable = value.split(' ')[0];
          rowIndex = `${this.$t(`general.months.${translatable}`)}`;
          shop = value.replace(value.split(' ')[0], '');
          attachTable = response.rows[value].countsData;
        } else {
          attachTable = response.rows[value].countsData;
          rowIndex = value.split(' ')[0];
          shop = value.replace(value.split(' ')[0], '');
        }
        const dto = {
          [this.$t('csvHeaders.date')]: rowIndex,
          [this.$t('csvHeaders.shop')]: shop,
          [this.$t('csvHeaders.rowSummary')]: response.rows[value].rowSummary,
          [this.$t('csvHeaders.minTemp')]: response.rows[value].minTemp,
          [this.$t('csvHeaders.maxTemp')]: response.rows[value].maxTemp,
          ...attachTable,
        };
        this.CSVOrder = [
          ...[this.$t('csvHeaders.date'), this.$t('csvHeaders.shop')],
          ...Object.keys(attachTable),
          ...[this.$t('csvHeaders.minTemp'), this.$t('csvHeaders.maxTemp'), this.$t('csvHeaders.rowSummary')]];
        csvdata.push(dto);
      });
      this.tableCSVData = csvdata;
    },
    getImgUrl() {
      return require('@/assets/images/weather/04.svg');
    },
    changeChart() {
      if (this.state === 0) {
        this.state = 1;
      } else {
        this.state = 0;
      }
    },
    async printCharts() {
      //  return false;
      this.printing = true;
      const font = require('@/styles/font.json');
      const canvasEle = [];
      if (this.state === 0) {
        this.chartCount = this.generatePrintedCharts();
        this.keyD += 1;
      }
      this.$nextTick(() => {
        const doc = new jsPDF({
          orientation: 'landscape',
          compress: true,
        });
        doc.addFileToVFS('nunito.ttf', font.nunito);
        doc.addFont('nunito.ttf', 'nunito', 'normal');
        doc.setFont('nunito', 'normal');
        doc.setFontSize(12);
        if (this.state === 0) {
          for (let i = 0; i < this.chartCount; i += 1) {
            canvasEle.push(document.getElementById(`printable-chart-${i}`).getElementsByTagName('canvas')[0]);
          }
        } else {
          canvasEle.push(document.getElementById('line-chart'));
        }
        setTimeout(() => {
          canvasEle.forEach((value, index) => {
            const imgData = value.toDataURL('image/jpg', 1.0);
            doc.addImage(imgData, 'JPEG', 30, 10, 250, 150, '', 'FAST');
            if (index < canvasEle.length - 1) {
              doc.addPage();
            }
          });
          // doc.addImage(logo, 126, 21);
          doc.autoTable({
            html: '#counts-table',
            startY: 300,
            styles: {
              font: 'nunito',
              fontStyle: 'normal',
              fontSize: 6,
              cellWidth: 3,
            },
            columnStyles: {
              0: {
                cellWidth: 5,
              },
              1: {
                cellWidth: 10,
              },
              25: { columnWidth: 5 },
              26: { columnWidth: 5 },
              27: { columnWidth: 5 },
              28: { columnWidth: 5 },
            },
          });
          doc.save();
          this.printChartData = [];
          this.printing = false;
        }, 5000);
      });
    },
    async getLogo(url, callback) {
      const xhr = new XMLHttpRequest();
      xhr.onload = function () {
        const reader = new FileReader();
        reader.onloadend = function () {
          callback(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open('GET', url);
      xhr.responseType = 'blob';
      xhr.send();
    },
  },
};
</script>

<style lang="scss" scoped>
    a {
        text-decoration: none;
        font-weight: bold;

        &:visited {
            color: #002678;
        }
    }

    button {
        cursor: pointer;
        text-transform: capitalize;
    }

    .switcheroo {
        align-items: center;
        display: flex;

        img {
            padding: 20px;
        }
    }

    .raptors-group {
        /*width: 100%;*/
        padding-left: 40px;
        padding-right: 55px;
        @include media('<1026px') {
            padding: 0;
        }

    }

    .top {
        margin-bottom: 20px;

        button {
            margin: 10px;
        }
    }

    .table-container {
        overflow: auto;

        .top {
            margin-bottom: 20px;
            display: flex;
            padding: 25px;
            align-items: center;

            button {
                margin: 10px;
            }
        }
    }

    .charts-container, .table-container {
        background: white;
        border-radius: 5px;
        padding: 20px 0;
        margin-top: 50px;
        margin-bottom: 50px;

        .top {
            margin-bottom: 20px;
        }

        .controls {
            border-top: 1px solid #e5e5e5;
            border-bottom: 1px solid #e5e5e5;
            padding: 40px 50px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            @include media('<755px') {
                flex-direction: column;
            }
        }

        .charts {
            max-height: 320px;
            overflow-y: auto;
        }

    }

    .link {
        display: flex;
        justify-content: space-between;
        align-items: center;

        img {
            margin-right: 15px;
        }
    }

    h4 {
        font-size: rem(16px);
        font-weight: bold;
        // color: $baseTextColor;
        text-transform: uppercase;
        text-align: left;
        margin-left: 33px;
        margin-top: 0;
    }

    /* The switch - the box around the slider */
    .switch {
        position: relative;
        display: inline-block;
        width: 60px;
        height: 34px;
    }

    /* Hide default HTML checkbox */
    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    /* The slider */
    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #9e9e9e;
        -webkit-transition: .4s;
        transition: .4s;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 26px;
        width: 26px;
        left: 4px;
        bottom: 4px;
        background-color: #002678;
        -webkit-transition: .4s;
        transition: .4s;
    }

    input:checked + .slider {
        background-color: #9e9e9e;
    }

    input:focus + .slider {
        box-shadow: 0 0 1px #9e9e9e;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
    }

    /* Rounded sliders */
    .slider.round {
        border-radius: 34px;
    }

    .slider.round:before {
        border-radius: 50%;
    }

    .date-control {
        /* color: #878a94; */
        font-size: rem(14px);
        font-weight: 900;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        @include media('<755px') {
            flex-direction: column;
        }

    }

    button {
        background: none;
        border: none;
        font-size: rem(14px);
        font-weight: 900;
        /* color: #878a94; */
        color: inherit;
        text-transform: capitalize;

        &:hover {
            color: $peacock-blue;
        }

    }

    .table {
        box-shadow: none;
    }

    .table-container {
        box-shadow: 0 5px 6px $baseShadow;
        overflow-x: auto;

        .top {
            button {
                text-transform: uppercase;
            }

            border-bottom: 1px solid #e5e5e5;
        }

        .tr {
            .td {
                padding: 13px;
            }

            &:first-child {
                .td {
                    border: none;
                    border-bottom: 1px solid $border-blue;
                    font-weight: bold;
                }
            }

            &:not(:last-child) {
                .td {
                    vertical-align: middle;
                    // border: 1px solid $border-gray;
                    border-bottom: 1px solid $border-gray;

                    &:first-child {
                        border-left: none;
                        border-right: 1px solid $border-gray;
                    }

                    &:nth-last-child(-n+4) {
                        border-right: none;
                        border-left: 1px solid $border-gray;

                    }

                    .weather-container {
                        display: flex;
                        justify-content: center;

                        img {
                            width: 45px;
                        }
                    }

                }
            }


            &:last-child {
                font-weight: bold;

                .td {
                    padding: 13px 0;
                    border-bottom: 1px solid $border-gray;

                    &:first-child, &:last-child {
                        border-right: 1px solid $border-gray;

                    }
                }
            }
        }
    }

    .link.download {
        font-weight: normal;

        > div {
            display: flex;
            align-items: center;
            cursor: pointer;
        }

        text-transform: capitalize;

        &:hover {
            color: $peacock-blue;
        }
    }

    .link.print {
        cursor: pointer;
        text-transform: capitalize;

        &:hover {
            color: $peacock-blue;
        }
    }

    .active {
        color: $peacock-blue;
    }

    .picker-container {
        padding-left: 15px;
        display: flex;
        align-items: center;
        color: $peacock-blue !important;

        input {
            color: $peacock-blue !important;
        }

    }

    .printing {
        height: 100vh;
        width: 100vw;
        position: fixed;
        background-color: white;
        top: 0;
        left: 0;
        z-index: 20000;
    }

    .save {
        padding: 10px 15px;
        color: white;
        border-radius: 15px;
        margin: 0 10px;
        font-weight: bold;
        text-transform: capitalize;
    }
</style>
